import "../css/dialog.css";
import classnames from "classnames";
import copy from "copy-to-clipboard";

function create(msg, mode) {
  setTimeout(() => {
    document.body.style.overflow = "hidden";
  }, 300);
  let mask = document.createElement("div");
  mask.className = "g-dialog-mask";
  let box = document.createElement("div");
  box.className = classnames("g-dialog-box");

  let div = document.createElement("div");
  div.className = classnames("g-dialog", mode == "dark" ? "g-dialog-dark" : "");
  let button = document.createElement("button");
  button.innerHTML = window.WEB_LOCALES_ALL["global.btn.back"];
  div.innerHTML = `<p>${msg}</p>`;

  div.appendChild(button);
  box.appendChild(div);
  mask.appendChild(box);
  if (!window.document.querySelector("#dialogmsg")) {
    createBox();
  }

  button.onclick = function () {
    document.body.style.overflow = "auto";
    mask.parentNode.removeChild(mask);
  };
  window.document.querySelector("#dialogmsg").appendChild(mask);
}

function createBox() {
  if (window.document.querySelector("#dialogmsg")) return;
  let div = document.createElement("div");
  div.id = "dialogmsg";
  div.className = "g-dialogmsg";
  window.document.body.appendChild(div);
}
window.addEventListener("load", createBox, false);

function error(msg, mode) {
  if (!msg) {
    return;
  }
  create(msg, mode);
}

export default { error };
